import { render } from "./PlanOfferingPresentation.vue?vue&type=template&id=795d0fef&scoped=true"
import script from "./PlanOfferingPresentation.vue?vue&type=script&lang=js"
export * from "./PlanOfferingPresentation.vue?vue&type=script&lang=js"

import "./PlanOfferingPresentation.vue?vue&type=style&index=0&id=795d0fef&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-795d0fef"]])

export default __exports__